// extracted by mini-css-extract-plugin
export default {"orange_container":"explore_orange_container__6NVnH","orange_container_title":"explore_orange_container_title__Gq6Rc","orange_container_text":"explore_orange_container_text__PhkIN"};